import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { vehicleService } from "../../../../../../Services/vehicle.service";
import { useSelected } from "../../../../../../contexts/SelectedContext";

export const useVehicleFilters = ({ vehicleSelected, showTopFilters }) => {
  const dispatch = useDispatch();
  const { selectedValues, setSelectedValues } = useSelected();

  const [dataGroup, setDataGroup] = useState([]);
  const [dataVehicle, setDataVehicle] = useState([]);
  const [filtersLoading, setFiltersLoading] = useState(false);
  const [isManualSelection, setIsManualSelection] = useState(false);

  const selectedGroup = selectedValues.veiculos?.[0] || null;
  const selectedVehicle = selectedValues.veiculosGroups?.[0] || null;

  const fetchVehicleGroups = async () => {
    try {
      setFiltersLoading(true);
      const groups = await vehicleService.fetchGroups();
      setDataGroup(groups);

      const groupId = groups?.length === 1 ? groups[0].vehicleGroupId : 0;
      const vehicles = await vehicleService.fetchVehicles(groupId);
      if (vehicles) setDataVehicle(vehicles);
    } catch (error) {
      console.error(error);
    } finally {
      setFiltersLoading(false);
    }
  };

  const fetchVehiclesByGroup = async (groupId) => {
    try {
      setFiltersLoading(true);
      const vehicles = await vehicleService.fetchVehicles(groupId);
      setDataVehicle(vehicles);
    } catch (error) {
      console.error(error);
    } finally {
      setFiltersLoading(false);
    }
  };

  useEffect(() => {
    if (showTopFilters) fetchVehicleGroups();
  }, [showTopFilters]);

  // Inicializa com veículo pré-selecionado
  useEffect(() => {
    if (!showTopFilters || !vehicleSelected?.vehicleId) return;

    const init = async () => {
      try {
        if (!dataGroup.length) {
          const groups = await vehicleService.fetchGroups();
          setDataGroup(groups);
        }

        setSelectedValues((prev) => ({
          ...prev,
          veiculos: vehicleSelected.vehicleGroupId
            ? [vehicleSelected.vehicleGroupId]
            : [],
          veiculosGroups: [vehicleSelected.vehicleId],
        }));

        const allVehicles = await vehicleService.fetchVehicles(
          vehicleSelected.vehicleGroupId ?? 0,
        );
        setDataVehicle(allVehicles || []);
      } catch (error) {
        console.error(error);
      }
    };

    init();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicleSelected?.vehicleId, setSelectedValues, showTopFilters]);

  // Atualiza veículos quando grupo muda manualmente
  useEffect(() => {
    if (!showTopFilters || selectedGroup === null || !isManualSelection) return;
    fetchVehiclesByGroup(selectedGroup);
    setIsManualSelection(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedGroup, isManualSelection, showTopFilters]);

  // Sincroniza redux quando veículo é selecionado manualmente
  useEffect(() => {
    if (
      !showTopFilters ||
      !selectedVehicle ||
      selectedVehicle === "TODOS" ||
      !isManualSelection
    )
      return;

    const found = dataVehicle.find(
      (v) =>
        v.vehicleId?.toString() === selectedVehicle.toString() ||
        v.groupVehicleId?.toString() === selectedVehicle.toString(),
    );

    if (found) {
      dispatch({ type: "vehicleSelected", value: found });
      setIsManualSelection(false);
    }
  }, [
    selectedVehicle,
    dataVehicle,
    dispatch,
    isManualSelection,
    showTopFilters,
  ]);

  return {
    dataGroup,
    dataVehicle,
    filtersLoading,
    selectedGroup,
    selectedVehicle,
    setIsManualSelection,
  };
};
